export enum SexEnum {
    Male = 1,
    Female
}

export enum LoginTypeEnum {
    Phone = 1,
    Email
}
